"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOrganizationPageButtonMockFields = void 0;
const icons_1 = require("../icons");
const buildOrganizationPageButtonMockFields = (organizationPageUrl, theme) => organizationPageUrl
    ? { organizationPageUrl, iconExternalLink: (0, icons_1.tintIconSvgDataUri)("externalLink", theme.tIntense) }
    : {};
exports.buildOrganizationPageButtonMockFields = buildOrganizationPageButtonMockFields;
